import { toast } from "react-toastify";

export function renderKoToast(error) {
  toast.error('Errore: ' + error, {
    position: 'top-center',
    autoClose: 1500, // Chiudi automaticamente dopo 3 secondi
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
  });
}

export function renderOkToast(message) {
  toast(message, {
    position: "top-center",
    autoClose: 1500,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    closeButton: false,
    style: {
      background: '#145444',
      color: 'white',
      borderRadius: '20px',
      // border: '1px solid #',
      textAlign: 'center',
      margin: '10px 10px'
    },
  });
}